import { Component, inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [ProgressSpinnerModule],
  template: `
    @if (loaderService.isLoading()) {
      <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm transition-opacity">
        <p-progressSpinner 
          ariaLabel="loading"
          styleClass="w-16 h-16"
          strokeWidth="4" 
        />
      </div>
    }
  `
})
export class LoaderComponent {
  public loaderService = inject(LoaderService);
}